import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { ensurePlatformPixel, platformTrack } from "@/lib/platformPixel";

/**
 * Mounts the platform-wide Meta Pixel on the apex app shell and fires a PageView
 * on every SPA navigation, so the whole seller-acquisition funnel is tracked.
 * Renders nothing. A no-op when the super-admin hasn't configured a pixel.
 *
 * Keyed on location.key (unique per history entry) so StrictMode's double-effect
 * dedupes to one PageView per navigation, while revisiting a route still counts.
 */
export function PlatformPixel() {
  const location = useLocation();

  useEffect(() => {
    void ensurePlatformPixel();
  }, []);

  useEffect(() => {
    void platformTrack("PageView", undefined, {
      dedupeKey: `platform:pageview:${location.key}`,
    });
  }, [location.key]);

  return null;
}
